import {
  DefaultApiGetUsersRequest,
  FilterOption,
  SubscriptionPlanType,
  UserRoleType,
} from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow } from "../../../components";
import { CheckboxListPopover } from "../../../components/CheckboxListPopover";
import { pluralizeString } from "../../../utils";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";

const roleFilterOptions: FilterOption[] = [
  { value: UserRoleType.Admin, label: "Admin" },
  { value: UserRoleType.Member, label: "Member" },
];

const planFilterOptions: FilterOption[] = [
  { value: SubscriptionPlanType.NewUser, label: "New User" },
  { value: SubscriptionPlanType.FreeTrial, label: "Free Trial" },
  { value: SubscriptionPlanType.LifetimeFree, label: "Lifetime Free" },
  { value: SubscriptionPlanType.Starter, label: "Starter" },
  { value: SubscriptionPlanType.Plus, label: "Plus" },
  { value: SubscriptionPlanType.Pro, label: "Pro" },
  { value: SubscriptionPlanType.Enterprise, label: "Enterprise" },
  { value: SubscriptionPlanType.Custom, label: "Custom" },
];

type Props = {
  search: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters<keyof DefaultApiGetUsersRequest>;
  setFilters: (filters: TableFilters<keyof DefaultApiGetUsersRequest>) => void;
};

export const DomainUsersFilterToolbar: React.FC<Props> = ({
  onSearchChange,
  search,
  filters,
  setFilters,
}) => {
  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <DebouncedSearchInput initialSearch={search} onChange={onSearchChange} />

      <FlexRow>
        <CheckboxListPopover
          getLabel={() =>
            filters.roles === undefined ||
            filters.roles.length === 0 ||
            filters.roles.length === roleFilterOptions.length
              ? "All Roles"
              : pluralizeString("Role", filters.roles.length)
          }
          initialValues={filters.roles}
          options={roleFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              roles: values as UserRoleType[],
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <CheckboxListPopover
          getLabel={() =>
            filters.plans === undefined ||
            filters.plans.length === 0 ||
            filters.plans.length === planFilterOptions.length
              ? "All Plans"
              : pluralizeString("Plan", filters.plans.length)
          }
          initialValues={filters.plans}
          options={planFilterOptions}
          onChange={values => {
            setFilters({
              ...filters,
              plans: values as SubscriptionPlanType[],
            });
          }}
          buttonProps={{
            className: "gray",
          }}
        />

        <ExportCSVButton tab={TabName.users} />
      </FlexRow>
    </FlexRow>
  );
};
